export const formatAsTitle = (text: string) => {
  if (!text) return ''
  return text
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const formatFileSize = (bytes: number): string => {
  const KB = 1024
  const MB = KB * 1024
  const GB = MB * 1024

  if (bytes < MB) {
    return `${(bytes / KB).toFixed(2)} KB`
  } else if (bytes < GB) {
    return `${(bytes / MB).toFixed(2)} MB`
  } else {
    return `${(bytes / GB).toFixed(2)} GB`
  }
}

export const colorToRGB = (
  colorVar: string,
  alpha = 1
): string => {
  const cssVarName = colorVar.replace(/^var\((--[^)]+)\)$/, '$1')
  const hexValue = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVarName)
    .trim()
    .replace('#', '')
  const numericValue = parseInt(hexValue, 16)
  const r = numericValue >> 16 & 0xFF
  const g = numericValue >> 8 & 0xFF
  const b = numericValue & 0xFF
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
